<template>
    <div class="form-group">
        <label class="form-label" :for="id"  :style="{ width: labelWidth }">
            <span v-if="required" style="color: #ff5a5a;">*</span>
            <span v-else style="visibility: hidden;">*</span>
            {{ label }}
        </label>
        <a-cascader
                :style="{ width: cascaderWidth }"
                :placeholder="placeholder"
                changeOnSelect
                v-decorator="decorator"
                :options="options"
                :fieldNames="fieldNames"
                @change="handleChange"
        />
    </div>
</template>

<script>
export default {
    name: "CascaderComponent",
    props: {
        cascaderWidth:{
            type:String,
            default:'70%'
        },
        labelWidth:{
            type:String,
            default:'40%'
        },
        label:{
            type: String,
            default: "label",
        },
        placeholder: {
            type: String,
            default: "请选择",
        },
        // 传入的装饰器配置
        decorator: {
            type: Array,
            required: true,
        },
        // 传入的选项数据
        options: {
            type: Array,
            required: true,
        },
        // 传入的字段名称映射
        fieldNames: {
            type: Object,
            default: () => ({
                label: "name",
                value: "id",
                children: "children",
            }),
        },
    },
    methods: {
        // 处理级联选择器的值变化
        handleChange(value) {
            this.$emit("change", value);
        },
    },
};
</script>
<style scoped>
.form-group {
    display: flex;
    align-items: center;
    width: 100%;
}

.form-label {
    display: block;
    color: #94a3b8;
    font-size: 0.9rem;
}

::v-deep .ant-cascader-picker .ant-cascader-menus {
    background: #0e1932 !important;
    color: #94a3b8 !important;
}

::v-deep .ant-cascader-menu-item.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled),
::v-deep .ant-cascader-menu-item.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {
    background-color: #354c7d !important;
}

::v-deep .ant-cascader-picker{
    background-color: #0e1932;
    color:#fff;
    padding: 1.4rem 0;
    border-radius: 10px;
    border: 1px solid #0b4846;
}
::v-deep .ant-cascader-picker-arrow{
    color: rgb(255 255 255 / 25%);
}
::v-deep .ant-input{
    display: none;
    height:80px;
}
</style>